import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;
// eslint-disable-next-line
if ( jQuery('#hotel-search-app').length > 0 ) {
  new Vue({
    render: h => h(App),
    data() {
      return {
        filters: [],
        App: {}
      }
    },
    mounted() {
      this.App = this.$children[0];
    }
  }).$mount('#hotel-search-app')  
}